import idx from 'idx'
import axios from 'axios'
import {API_URL, SAUCE_API_URL} from 'config'
import {push} from 'connected-react-router'

import initialState from 'reducers/initialState'
import errorDispatcher from 'utils/errorDispatcher'
import {getAuthorizationHeader} from 'utils/session'
import {extractErrorCode} from "utils/api";

// Actions
export const API_CHECK_TOKEN_REQUEST = 'API_CHECK_TOKEN_REQUEST'
export const API_CHECK_TOKEN_SUCCESS = 'API_CHECK_TOKEN_SUCCESS'
export const API_CHECK_TOKEN_ERROR = 'API_CHECK_TOKEN_ERROR'

// Reducer
export default function reducer(state = initialState.invites, action) {
    switch (action.type) {
        default:
        case API_CHECK_TOKEN_SUCCESS:
            return {
                ...state,
                tokenChecked: true
            }
    }
}

// Action Creators
export function checkTokenVerification(inviteUUID, token, callback) {
    return async function dispatcher(dispatch) {
        dispatch({type: API_CHECK_TOKEN_REQUEST})

        try {
            await axios.get(`${SAUCE_API_URL}/invites${inviteUUID ? `/${inviteUUID}` : ''}?token=${token}`).then((result) => {
                const data = idx(result, _ => _.data.data)
                dispatch({type: API_CHECK_TOKEN_SUCCESS})

                if (callback) {
                    dispatch(() => callback(data))
                }
            })
                .catch((error) => {
                    return Promise.reject(error)
                })
        }
        catch (error) {
            const errorCode = idx(error, _ => _.response.data.status) || ''
            errorDispatcher(errorCode, API_CHECK_TOKEN_ERROR, dispatch)
        }
    }
}

export function acceptTrapInvitation(inviteUUID, token) {
    return async function dispatcher(dispatch) {
        try {
            await axios.put(`${SAUCE_API_URL}/invites/${inviteUUID}`, {token}).then(() => {
                dispatch({type: API_CHECK_TOKEN_SUCCESS})
                dispatch(push('/invitation/trap/success'))
            })
                .catch((error) => {
                    return Promise.reject(error)
                })
        }
        catch (error) {
            const errorCode = idx(error, _ => _.response.data.status) || ''
            errorDispatcher(errorCode, API_CHECK_TOKEN_ERROR, dispatch)
        }
    }
}

export function acceptAdminInvitation(token) {
    return async function dispatcher(dispatch) {
        try {
            await axios.post(`${API_URL}/project/accept-admin-invitation/${token}`, null, getAuthorizationHeader())
            dispatch({type: API_CHECK_TOKEN_SUCCESS})
            dispatch(push('/invitation/admin/success'))
        }
        catch (error) {
            const errorCode = extractErrorCode(error, "acceptAdminInvitation")
            errorDispatcher(errorCode, API_CHECK_TOKEN_ERROR, dispatch)
        }
    }
}



// WEBPACK FOOTER //
// ./src/modules/invite.js